import { createStore } from 'satcheljs';
export default createStore('themeOption', {
    isQuickOptionExpanded: false,
});
//# sourceMappingURL=store.js.map